import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedSearches = ({ onSearchSelect, onClose }) => {
  const [savedSearches] = useState([
    {
      id: 1,
      name: "Safety Procedures Updates",
      query: "safety procedures updated in last 30 days",
      createdAt: "2024-11-10T10:30:00Z",
      resultCount: 15,
      alertEnabled: true
    },
    {
      id: 2,
      name: "HR Policy Documents",
      query: "HR policies employee handbook",
      createdAt: "2024-11-08T14:20:00Z",
      resultCount: 8,
      alertEnabled: false
    },
    {
      id: 3,
      name: "Compliance Requirements",
      query: "compliance requirements regulations",
      createdAt: "2024-11-05T09:15:00Z",
      resultCount: 23,
      alertEnabled: true
    },
    {
      id: 4,
      name: "Training Materials",
      query: "training materials new employee onboarding",
      createdAt: "2024-11-02T16:45:00Z",
      resultCount: 12,
      alertEnabled: false
    }
  ]);

  const formatDate = (dateString) => {
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  const handleSearchSelect = (search) => {
    onSearchSelect(search?.query);
    onClose();
  };

  const handleToggleAlert = (searchId) => {
    // In a real app, this would update the alert status
    console.log('Toggle alert for search:', searchId);
  };

  const handleDeleteSearch = (searchId) => {
    // In a real app, this would delete the saved search
    console.log('Delete search:', searchId);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card border border-border rounded-lg w-full max-w-2xl mx-4 max-h-[80vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <Icon name="Bookmark" size={24} className="text-primary" />
            <h2 className="text-xl font-semibold text-card-foreground">Saved Searches</h2>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            iconName="X"
            iconSize={20}
          />
        </div>

        {/* Saved Searches List */}
        <div className="overflow-y-auto max-h-96">
          {savedSearches?.length === 0 ? (
            <div className="p-8 text-center">
              <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Bookmark" size={32} className="text-muted-foreground" />
              </div>
              <h3 className="text-lg font-medium text-card-foreground mb-2">No saved searches</h3>
              <p className="text-muted-foreground">
                Save your frequently used searches for quick access.
              </p>
            </div>
          ) : (
            <div className="divide-y divide-border">
              {savedSearches?.map((search) => (
                <div key={search?.id} className="p-4 hover:bg-muted/50 transition-colors">
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-2">
                        <h3 className="font-medium text-card-foreground truncate">
                          {search?.name}
                        </h3>
                        {search?.alertEnabled && (
                          <div className="flex items-center gap-1 text-xs text-success">
                            <Icon name="Bell" size={12} />
                            <span>Alert On</span>
                          </div>
                        )}
                      </div>
                      
                      <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                        "{search?.query}"
                      </p>
                      
                      <div className="flex items-center gap-4 text-xs text-muted-foreground">
                        <span className="flex items-center gap-1">
                          <Icon name="Calendar" size={12} />
                          Saved {formatDate(search?.createdAt)}
                        </span>
                        <span className="flex items-center gap-1">
                          <Icon name="FileText" size={12} />
                          {search?.resultCount} results
                        </span>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-1">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => handleSearchSelect(search)}
                        iconName="Search"
                        iconSize={16}
                      >
                        Search
                      </Button>
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleToggleAlert(search?.id)}
                        iconName={search?.alertEnabled ? "BellOff" : "Bell"}
                        iconSize={16}
                        className={search?.alertEnabled ? "text-success" : "text-muted-foreground"}
                      />
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDeleteSearch(search?.id)}
                        iconName="Trash2"
                        iconSize={16}
                        className="text-destructive hover:text-destructive"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-border bg-muted/30">
          <p className="text-xs text-muted-foreground text-center">
            Tip: Enable alerts to get notified when new documents match your saved searches
          </p>
        </div>
      </div>
    </div>
  );
};

export default SavedSearches;